//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {formatDate} from '../../../src/lib/date';

const coupon = {
    // available: 1,
    // condition: '无使用门槛\n最多优惠12元',
    // reason: '',
    // value: 150,
    // name: '优惠券名称',
    // startAt: 1489104000,
    // endAt: 1514592000,
    // valueDesc: '1.5',
    // unitDesc: '元',
    // emptyImage: "https://ig.yzcdn.cn/vant/coupon-empty.png",
    // description: '描述信息',//描述信息
};
const discoupon = {
    // available: 1,
    // condition: '无使用门槛\n最多优惠12元',
    // reason: '',
    // value: 150,
    // name: '优惠券名称',
    // startAt: 1489104000,
    // endAt: 1514592000,
    // valueDesc: '15',
    // unitDesc: '元'
};
export default {
    name: "my-coupon",
    filters: {
        formatDate(time, type) {
            var date = new Date(time);
            if (type === 1) {
                return formatDate(date, 'yyyy-MM-dd');
            }
            return formatDate(date, 'yyyy-MM-dd hh:mm');
        }
    },
    data() {
        return {
            active: '',
            showList: true,
            chosenCoupon: -1,
            coupons: [coupon],
            disabledCoupons: [discoupon],
            loading: false,
            emptyImage: "https://ig.yzcdn.cn/vant/coupon-empty.png",
            memberInfo: {}
        }
    },
    methods: {
        onChange(index) {
            this.showList = false;
            this.chosenCoupon = index;
            var item = this.coupons[index];
            this.$router.push({path: '/couponDetail/' + item.id})
        },
        onExchange(code) {
            this.coupons.push(coupon);

        },
        getPage() {
            abp.ajax.get('/api/services/app/Coupon/GetMyCoupons', {
                params: {
                    used: false,
                    expired: false,
                }
            }).then(res => {
                this.coupons = [];
                if (res.data.result.length > 0 && res.data.result != null) {
                    res.data.result.forEach((item, index) => {
                        // console.log(item);
                        this.coupons.push({
                            id: item.id,
                            name: item.coupon.name,
                            available: 1,
                            condition: item.coupon.name,
                            startAt: new Date(item.coupon.startTime).getTime() / 1000,
                            endAt: (new Date(item.coupon.endTime)).getTime() / 1000,
                            description: item.coupon.description,
                            reason: '',
                            value: item.coupon.faceValue,
                            valueDesc: item.coupon.faceValue,
                            unitDesc: item.coupon.type == 0 ? '元' : '折',

                        })
                    });
                }
            })
        },
        getDisCoupons() {
            abp.ajax.get('/api/services/app/Coupon/GetMyCoupons', {
                params: {
                    // used: true,
                    expired: true
                }
            }).then(res => {
                this.disabledCoupons = [];
                if (res.data.result.length > 0 && res.data.result != null) {
                    res.data.result.forEach((item, index) => {
                        // console.log(item);
                        this.disabledCoupons.push({
                            id: item.id,
                            name: item.coupon.name,
                            available: 1,
                            condition: item.coupon.name,
                            startAt: new Date(item.coupon.startTime).getTime() / 1000,
                            endAt: (new Date(item.coupon.endTime)).getTime() / 1000,
                            description: item.coupon.description,
                            reason: '',
                            value: item.coupon.faceValue,
                            valueDesc: item.coupon.faceValue,
                            unitDesc: item.coupon.type == 0 ? '元' : '折',

                        })
                    });
                }
            })
        },
        async getMyMember() {
            this.$toast.loading({
                duration: 0,
                message: ''
            });
            await this.$store.dispatch({
                type: 'member/getMyMember'
            }).then(() => {
                this.memberInfo = this.$store.state.member.memberInfo;
                localStorage.setItem('MemberId', this.memberInfo.id);

                this.getPage();
                this.getDisCoupons();

            }).finally(() => {
                this.$toast.clear();
            });
        },
    },
    created() {
        this.getMyMember();
    }
}
